<!-- 保密局项目页面底部 -->
<template>
<div :class="mobileClass('cm_bottom_container')">
  <img src="@/assets/img/bottom-bd.png" class="cm_bottom_bd">
  <div :class="mobileClass('cm_bottom_box')">
    <div class="cm_bottom_box_content" >
      <span>单位名称：内蒙古自治区国家保密局　<a href="https://beian.miit.gov.cn/#/Integrated/index">蒙ICP备17003814号</a></span>
      <span>单位地址：内蒙古自治区呼和浩特市赛罕区敕勒川大街2号</span>
      <span>对外联络电话：0471-4813610　传真：0471-4951137</span>
      <span>泄密举报电话：0471-4818813　泄密举报邮箱: bmj@nmww.gov.cn</span>
      <span>印制资质咨询电话：0471-4813205</span>
      <span>集成资质咨询电话：0471-4818687</span>
      <span>军工资格电话：0471-4818713</span>
    </div>
    <div id="logo_link">
      <span id='_ideConac' ></span>
    </div>
    <div class="cm_bottom_box_content">
      <span>总访问量：{{cutData.totalCount}}　|　当日访问总量：{{cutData.currentTotalCount}}</span>
      <span>总访问IP量：{{cutData.ipTotalCount}}　|　当日访问IP量：{{cutData.currentIpTotalCount}}</span>
    </div>
  </div>
</div>
</template>

<script>
import load from '../../utils/buttomLogo'
export default {
components: {},
data() {
return {
  cutData:"",
  windowWidth:document.documentElement.clientWidth
};
},
computed: {
  mobileClass(){
       return (val)=>{
         if(this.windowWidth > 500) {
          return val
          } else {
            return "mobile_"+val
          }
       }
    },
},
//监控data中的数据变化
watch: {
  '$store.state.screenWidth': function (val) { //监听屏幕宽度变化
    this.windowWidth = val;
  }
},
//方法集合
methods: {
  httpPost() {
      this.$http({
        url: this.$http.adornUrl('requestMainMobile/webService/accessStatistics'),
        method: 'post',
        data: {}
      }).then(({ data }) => {
        if(data.data!=''&&data.data!=undefined&&data.data!=null){
          this.cutData = data.data
        }

      });
    },
    writeLogo(){
      load("https://dcs.conac.cn/js/07/000/0000/60785113/CA070000000607851130001.js", (err) => {//tinymceCDN代表tinymce的CDN地址，下一个参数是回调方法
        if (err) {//若脚本加载错误，这弹出错误提示
         this.$message.error(err.message)
         return
        }
       })

      // logoScript.addEventListener('load',e =>{
      //   setTimeout(this.marker,500);
      // })

    }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
  this.httpPost()
  this.writeLogo()
},

}
</script>
<style scoped>
.cm_bottom_container{
  width: 100%;
  height: 170px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  position: relative;
  padding-bottom: 25px;
}
.cm_bottom_bd{
  position: absolute;
  bottom: 0;
  z-index: -1;
  left: 0;
  right: 0;
  width:100%;
}
.cm_bottom_box{
  width: 1200px;
  height: 160px;
  padding: 0 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.cm_bottom_box span{
  width: 100%;
  font-size:14px;
  color:rgba(255,255,255,1)
}
.cm_bottom_box a{
  color:rgba(255,255,255,1)
}
.cm_bottom_box_content{
  display:flex;
  flex-wrap: wrap;
  height: 50%;
  align-content: space-between;
}
.cm_bottom_box_content>span>a{
  margin-left: 20px;
}
#logo_link{
  position: absolute;
  left: 618px;
}
/**手机适配 */
.mobile_cm_bottom_container{
  width: 100%;
  height: 360px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  position: relative;
  padding-bottom: 25px;
}
.mobile_cm_bottom_box{
  width: 100%;
  padding: 0 20px;
  display: flex;
  align-items: center;
  position: relative;
  flex-wrap: wrap;
}
.mobile_cm_bottom_box #logo_link{
  position: absolute;
  left: 380px;
  bottom: 10px;
}

.mobile_cm_bottom_box>.cm_bottom_box_content>span{
  padding: 5px 0;
}
</style>
